import {
    setLogo, setLine, setFontFamily, setLocationsListStyle, setLeftPanelBg, setRightPanelBg,
    setGauge, setGaugleTitle, setGaugeLabel, setGaugeOccupiedBg,
    setGaugeOffsetBg, setGaugeNeedleBg, setText
} from './index'
// ------------------------------------History handle set function
export const SET_ENTITY = 'SET_ENTITY'
export function setEntity(entity) {
    return {
        type: SET_ENTITY,
        entity
    };
}

export const SET_ENTITY_FONT = 'SET_ENTITY_FONT'
export function setEntityFont(entity) {
    return {
        type: SET_ENTITY_FONT,
        entity
    }
}

export const EMPTY_ENTITY = 'EMPTY_ENTITY'
export function emptyEntity(slideCurrentIndex, entity) {
    return {
        type: EMPTY_ENTITY,
        slideCurrentIndex,
        entity
    };
}

export const SET_STEP_NUMBER_STATE = 'SET_STEP_NUMBER_STATE'
export function setStepNumberState(step) {
    return {
        type: SET_STEP_NUMBER_STATE,
        step
    };
}


export const CLEAR_HISTORY = 'CLEAR_HISTORY'
export function clearHistory(slideCurrentIndex, payload) {
    return {
        type: CLEAR_HISTORY,
        slideCurrentIndex,
        payload
    }
}

export const OVERWRITE_HISTORY = 'OVERWRITE_HISTORY'
export function overWriteHistory(slideCurrentIndex, payload) {
    return {
        type: OVERWRITE_HISTORY,
        slideCurrentIndex,
        payload
    }
}

// ------------------------------------History handle set function
export function setCurrentEntity(entity) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        entity.slideCurrentIndex = slideCurrentIndex
        dispatch(setEntity(entity))
        dispatch(setStepNumberState(historyEntities.length))
    }
}

export function setEmptyEntity() {
    return (dispatch, getState) => {
        const { slideCurrentIndex, livefeedSlides } = getState().livefeededitor;
        const { historyEntities, fontFamily } = livefeedSlides.slice()[slideCurrentIndex];
        let entity = {
            id: null,
            fontFamily: fontFamily
        }
        dispatch(emptyEntity(slideCurrentIndex, entity))
        dispatch(setStepNumberState(historyEntities.length))
    }
}

export function updateCurrentEntity(entity) {
    return handleOverwriteHistory(updateCurrentEntity, setCurrentEntity, entity, true)
}

export function handleClearHistory(slideCurrentIndex) {
    return (dispatch, getState) => {
        const { livefeedSlides } = getState().livefeededitor;
        const { fontFamily } = livefeedSlides.slice()[slideCurrentIndex];
        let payload = [{
            id: null,
            fontFamily: fontFamily
        }]
        dispatch(clearHistory(slideCurrentIndex, payload))
    }
}
//----------------------- Handle OverWrite History --------------------------
export function handleOverwriteHistory(recursionFn, callbackSetFn, entity, isSetCurrentEntity) {
    return (dispatch, getState) => {
        const { slideCurrentIndex, stepNumberState } = getState().livefeededitor;
        const { historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        const history = historyEntities.slice(0);
        // If current stepNumberState < historyEntities last index, activate overWriteHistory
        if (stepNumberState < history.length - 1) {
            dispatch(overWriteHistory(slideCurrentIndex, history.slice(0, stepNumberState + 1)));
            entity !== false ? dispatch(recursionFn(entity)) : dispatch(recursionFn())
        }
        else {
            // no enity means callbackSetFn is updateEmptyEntity
            if (entity !== false) {
                dispatch(callbackSetFn(entity))
                // check if is updateCurrentEntity which already have setCurrentEntity
                if (!isSetCurrentEntity) {
                    // payload.id = null mean that is an entityFont hence no need to setCurrentEntity but need to setStepNumberState
                    entity.id !== null ? dispatch(setCurrentEntity(entity)) : dispatch(setStepNumberState(historyEntities.length))
                }
            } else {
                dispatch(callbackSetFn())
            }
        }
    }
}

// undo/redo handle here
export function changeHistory(step) {
    return (dispatch) => {
        dispatch(setStepNumberState(step));
        dispatch(updateEntityState(step))
    }
}

// call this function when change history of move
export function updateEntityState(step) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        const history = historyEntities.slice(0, step + 1);
        let currentEntity = history[step];
        switch (currentEntity.id) {
            case "logo":
                dispatch(setLogo(currentEntity))
                break;
            case "line":
                dispatch(setLine(currentEntity))
                break;
            case null: {
                let font = currentEntity.fontFamily === undefined ? "GTWalsheimProRegular" : currentEntity.fontFamily
                dispatch(setFontFamily(slideCurrentIndex, font))
            }
                break;
            case "locationsListStyle":
                dispatch(setLocationsListStyle(currentEntity))
                break;
            case "leftPanelBg":
                dispatch(setLeftPanelBg(currentEntity))
                break;
            case "rightPanelBg":
                dispatch(setRightPanelBg(currentEntity))
                break;
            case "gauge0":
                dispatch(setGauge(currentEntity))
                break;
            case "gauge1":
                dispatch(setGauge(currentEntity))
                break;
            case "gauge2":
                dispatch(setGauge(currentEntity))
                break;
            case "rightPanelTextTitle":
                dispatch(setGaugleTitle(currentEntity))
                break;
            case "rightPanelGaugeValueLabel":
                dispatch(setGaugeLabel(currentEntity))
                break;
            case "rightPanelGaugeOccupiedBg":
                dispatch(setGaugeOccupiedBg(currentEntity))
                break;
            case "rightPanelGaugeOffsetdBg":
                dispatch(setGaugeOffsetBg(currentEntity))
                break;
            case "rightPanelGaugeNeedle":
                dispatch(setGaugeNeedleBg(currentEntity))
                break;

        }
        typeof currentEntity.id == 'number' && dispatch(setText(currentEntity)) // if entity is an obj in textContainer arr
    }
}



// WEBPACK FOOTER //
// ./src/actions/livefeed/historyActions.js